// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.isp_container__Mxll1 {
  width: 100%;
  height: 100%;
  border: 1px solid var(--sb-border-color);
  border-top: none;
  padding: 18px 24px 0 26px;
}
.isp_container__Mxll1 .isp_buttonClicked__-YmtF {
  width: 20px;
  height: 20px;
  margin-top: 10px;
  font-size: 12px;
  background: linear-gradient(160.35deg, #FFA329 13.16%, #FE7B1C 42.24%, #FC2A01 71.32%);
  border: 1px solid #777778;
  border-radius: 15px;
  margin-right: 60px;
}
.isp_container__Mxll1 .isp_buttonNotClicked__uZtdB {
  width: 20px;
  height: 20px;
  margin-top: 10px;
  background: var(--sb-bg-color);
  box-sizing: border-box;
  border: 1px solid #777778;
  border-radius: 10px;
  margin-right: 60px;
}
.isp_container__Mxll1 .isp_paymentMethod__Zi-eo span {
  width: 36px;
  height: 18px;
  font-weight: 700;
  font-family: Red Hat Display;
  font-size: 12px;
  color: var(--font-color);
  margin-left: 25px;
}
.isp_container__Mxll1 .isp_selectPlan__uZQ3D {
  width: 100%;
  background-color: var(--re-select-dark-bg);
  border-radius: 12px;
  border: 1px solid transparent;
  color: var(--font-dark-color);
  font-family: Red Hat Display;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding: 11px 20px 10px 16px;
  margin-top: 17px;
}
@media (max-width: 781px) {
  .isp_container__Mxll1 {
    padding: 11px 14px 0 14px;
  }
}
.isp_container__Mxll1 .isp_brand__S6faF {
  display: flex;
}
.isp_container__Mxll1 .isp_brand__S6faF svg {
  width: 36px;
  height: 36px;
}
.isp_container__Mxll1 .isp_brand__S6faF span {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 38px;
  margin-left: 6px;
}
@media (max-width: 781px) {
  .isp_container__Mxll1 .isp_brand__S6faF span {
    font-size: 16px;
  }
}
.isp_container__Mxll1 select {
  margin-top: 10px;
}
@media (max-width: 781px) {
  .isp_container__Mxll1 select {
    height: 42px;
  }
}
.isp_container__Mxll1 .isp_paymentLabel__blDN5 {
  display: flex;
  margin-top: 13px;
}
.isp_container__Mxll1 .isp_paymentLabel__blDN5 span {
  color: var(--re-from-color);
  font-family: Red Hat Display;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.isp_container__Mxll1 .isp_lab__TZ4wK {
  width: 100%;
  height: 320px;
  max-height: 320px;
  min-height: 320px;
  border: 1px solid var(--re-border-color);
  border-radius: 12px;
  padding: 20px 20px 23px 20px;
  position: relative;
  margin-top: 13px;
}
@media screen and (max-width: 781px) {
  .isp_container__Mxll1 .isp_lab__TZ4wK {
    padding: 16px 20px 23px 20px;
    height: 270px;
  }
}
.isp_container__Mxll1 .isp_lab__TZ4wK span {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
@media screen and (max-width: 781px) {
  .isp_container__Mxll1 .isp_lab__TZ4wK span {
    font-size: 24px;
  }
}
.isp_container__Mxll1 .isp_lab__TZ4wK .isp_labList__hFog- {
  width: 100%;
  height: 160px;
  max-height: 160px;
  min-height: 160px;
  margin-top: 16px;
  overflow-y: hidden;
  overflow-x: hidden;
}
@media screen and (max-width: 781px) {
  .isp_container__Mxll1 .isp_lab__TZ4wK .isp_labList__hFog- {
    margin-top: 8px;
  }
}
.isp_container__Mxll1 .isp_lab__TZ4wK .isp_labList__hFog- .isp_labItem__o\\+Hok {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
}
.isp_container__Mxll1 .isp_lab__TZ4wK .isp_labList__hFog- .isp_labItem__o\\+Hok .isp_moreItemText__3EwO8 {
  margin-left: 7px;
}
.isp_container__Mxll1 .isp_lab__TZ4wK .isp_labList__hFog-::-webkit-scrollbar,
.isp_container__Mxll1 .isp_lab__TZ4wK ::-webkit-scrollbar-thumb,
.isp_container__Mxll1 .isp_lab__TZ4wK ::-webkit-scrollbar-track {
  background-color: var(--bg-color);
}
.isp_container__Mxll1 .isp_lab__TZ4wK .isp_from__MgaK4 {
  color: var(--re-from-color);
  font-family: Red Hat Display;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 15px;
}
.isp_container__Mxll1 .isp_lab__TZ4wK .isp_labInfo__RjvDF {
  min-width: 100%;
  max-width: 100%;
  display: flex;
  margin-top: 2px;
}
.isp_container__Mxll1 .isp_lab__TZ4wK .isp_labInfo__RjvDF span {
  margin-right: auto;
}
.isp_container__Mxll1 .isp_lab__TZ4wK .isp_labInfo__RjvDF button {
  line-height: 16px;
}
.isp_container__Mxll1 .isp_lab__TZ4wK .isp_labInfo__RjvDF button svg {
  top: 35%;
}
.isp_container__Mxll1 .isp_lab__TZ4wK .isp_logo__YpGXt {
  width: 53px;
  height: 38px;
  position: absolute;
  top: 17px;
  right: 24px;
}
.isp_container__Mxll1 .isp_amount__uPrGe {
  width: 100%;
  height: 440px;
  background-color: var(--sb-bg-color);
  border-radius: 12px;
  margin-top: 16px;
  padding: 11px 20px 20px;
}
.isp_container__Mxll1 .isp_amount__uPrGe .isp_selectPlan__uZQ3D {
  width: 100%;
  background-color: var(--hover-bg-color);
  border-radius: 12px;
  border: 1px solid transparent;
  color: var(--font-dark-color);
  font-family: Red Hat Display;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding: 11px 20px 10px 16px;
  margin-top: 17px;
}
.isp_container__Mxll1 .isp_amount__uPrGe .isp_title__Wi1Uw {
  display: flex;
}
@media screen and (max-width: 781px) {
  .isp_container__Mxll1 .isp_amount__uPrGe .isp_title__Wi1Uw svg {
    width: 32px;
    height: 32px;
  }
}
.isp_container__Mxll1 .isp_amount__uPrGe .isp_title__Wi1Uw span {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 39px;
  margin-left: 6px;
}
@media screen and (max-width: 781px) {
  .isp_container__Mxll1 .isp_amount__uPrGe .isp_title__Wi1Uw span {
    font-size: 18px;
    line-height: 30px;
  }
}
.isp_container__Mxll1 .isp_amount__uPrGe .isp_dataLabel__7VrT\\+ {
  display: flex;
  margin-top: 13px;
}
.isp_container__Mxll1 .isp_amount__uPrGe .isp_dataLabel__7VrT\\+ span {
  color: var(--re-from-color);
  text-align: right;
  font-family: Red Hat Display;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.isp_container__Mxll1 .isp_amount__uPrGe .isp_dataLabel__7VrT\\+ span:first-child {
  margin-left: 9px;
}
.isp_container__Mxll1 .isp_amount__uPrGe .isp_dataLabel__7VrT\\+ span:last-child {
  margin-left: auto;
}
.isp_container__Mxll1 .isp_amount__uPrGe .isp_price__opawT {
  display: flex;
  margin-top: 3px;
}
.isp_container__Mxll1 .isp_amount__uPrGe .isp_price__opawT span {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.isp_container__Mxll1 .isp_amount__uPrGe .isp_price__opawT span:first-child {
  margin-left: 9px;
}
.isp_container__Mxll1 .isp_amount__uPrGe .isp_price__opawT span:last-child {
  margin-left: auto;
}
.isp_container__Mxll1 .isp_amount__uPrGe .isp_button__gIRjY {
  width: 100%;
  display: flex;
  margin-top: 14px;
}
@media screen and (max-width: 781px) {
  .isp_container__Mxll1 .isp_amount__uPrGe .isp_button__gIRjY button {
    height: 38px !important;
  }
}
.isp_container__Mxll1 .isp_amount__uPrGe .isp_button__gIRjY button:last-child {
  margin-left: 11px;
}
.isp_container__Mxll1 .isp_amount__uPrGe .isp_button__gIRjY img {
  top: 22%;
}`, "",{"version":3,"sources":["webpack://./src/components/Layouts/isp/isp.module.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,wCAAA;EACA,gBAAA;EACA,yBAAA;AACJ;AACI;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,sFAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AACR;AAGI;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,8BAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AADR;AAMQ;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,4BAAA;EACA,eAAA;EACA,wBAAA;EACA,iBAAA;AAJZ;AASI;EACI,WAAA;EACA,0CAAA;EACA,mBAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,4BAAA;EACA,gBAAA;AAPR;AAUI;EA3DJ;IA4DQ,yBAAA;EAPN;AACF;AASI;EACI,aAAA;AAPR;AASQ;EACI,WAAA;EACA,YAAA;AAPZ;AAUQ;EACI,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AARZ;AAUY;EATJ;IAUQ,eAAA;EAPd;AACF;AAWI;EACI,gBAAA;AATR;AAWQ;EAHJ;IAIQ,YAAA;EARV;AACF;AAWI;EACI,aAAA;EACA,gBAAA;AATR;AAWQ;EACI,2BAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AATZ;AAeI;EACI,WAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,wCAAA;EACA,mBAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;AAbR;AAeQ;EAXJ;IAYQ,4BAAA;IACA,aAAA;EAZV;AACF;AAcQ;EACI,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAZZ;AAcY;EARJ;IASQ,eAAA;EAXd;AACF;AAcQ;EACI,WAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAZZ;AAcY;EATJ;IAUQ,eAAA;EAXd;AACF;AAaY;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAXhB;AAagB;EACI,gBAAA;AAXpB;AAgBQ;;;EAGI,iCAAA;AAdZ;AAiBQ;EACI,2BAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAfZ;AAkBQ;EACI,eAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;AAhBZ;AAkBY;EACI,kBAAA;AAhBhB;AAmBY;EACI,iBAAA;AAjBhB;AAmBgB;EACI,QAAA;AAjBpB;AAsBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AApBZ;AAwBI;EACI,WAAA;EACA,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAtBR;AAwBQ;EACI,WAAA;EACA,uCAAA;EACA,mBAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,4BAAA;EACA,gBAAA;AAtBZ;AAyBQ;EACI,aAAA;AAvBZ;AAyBY;EACI;IACI,WAAA;IACA,YAAA;EAvBlB;AACF;AA0BY;EACI,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAxBhB;AA0BgB;EATJ;IAUQ,eAAA;IACA,iBAAA;EAvBlB;AACF;AA2BQ;EACI,aAAA;EACA,gBAAA;AAzBZ;AA2BY;EACI,2BAAA;EACA,iBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAzBhB;AA4BY;EACI,gBAAA;AA1BhB;AA6BY;EACI,iBAAA;AA3BhB;AA+BQ;EACI,aAAA;EACA,eAAA;AA7BZ;AA+BY;EACI,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA7BhB;AAgCY;EACI,gBAAA;AA9BhB;AAiCY;EACI,iBAAA;AA/BhB;AAmCQ;EACI,WAAA;EACA,aAAA;EACA,gBAAA;AAjCZ;AAmCY;EACI;IACI,uBAAA;EAjClB;AACF;AAoCY;EACI,iBAAA;AAlChB;AAqCY;EACI,QAAA;AAnChB","sourcesContent":[".container {\n    width: 100%;\n    height: 100%;\n    border: 1px solid var(--sb-border-color);\n    border-top: none;\n    padding: 18px 24px 0 26px;\n\n    .buttonClicked {\n        width: 20px;\n        height: 20px;\n        margin-top: 10px;\n        font-size: 12px;\n        background: linear-gradient(160.35deg, #FFA329 13.16%, #FE7B1C 42.24%, #FC2A01 71.32%);\n        border: 1px solid #777778;\n        border-radius: 15px;\n        margin-right: 60px;\n\n    }\n\n    .buttonNotClicked {\n        width: 20px;\n        height: 20px;\n        margin-top: 10px;\n        background: var(--sb-bg-color);\n        box-sizing: border-box;\n        border: 1px solid #777778;\n        border-radius: 10px;\n        margin-right: 60px;\n    }\n\n    .paymentMethod {\n\n        span {\n            width: 36px;\n            height: 18px;\n            font-weight: 700;\n            font-family: Red Hat Display;\n            font-size: 12px;\n            color: var(--font-color);\n            margin-left: 25px;\n        }\n\n    }\n\n    .selectPlan {\n        width: 100%;\n        background-color: var(--re-select-dark-bg);\n        border-radius: 12px;\n        border: 1px solid transparent;\n        color: var(--font-dark-color);\n        font-family: Red Hat Display;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: normal;\n        padding: 11px 20px 10px 16px;\n        margin-top: 17px;\n    }\n\n    @media (max-width: 781px) {\n        padding: 11px 14px 0 14px;\n    }\n\n    .brand {\n        display: flex;\n\n        svg {\n            width: 36px;\n            height: 36px;\n        }\n\n        span {\n            color: var(--font-color);\n            font-family: Red Hat Display;\n            font-size: 20px;\n            font-style: normal;\n            font-weight: 700;\n            line-height: 38px;\n            margin-left: 6px;\n\n            @media (max-width: 781px) {\n                font-size: 16px;\n            }\n        }\n    }\n\n    select {\n        margin-top: 10px;\n\n        @media (max-width: 781px) {\n            height: 42px;\n        }\n    }\n\n    .paymentLabel {\n        display: flex;\n        margin-top: 13px;\n\n        span {\n            color: var(--re-from-color);\n            font-family: Red Hat Display;\n            font-size: 15px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: normal;\n\n        }\n\n    }\n\n    .lab {\n        width: 100%;\n        height: 320px;\n        max-height: 320px;\n        min-height: 320px;\n        border: 1px solid var(--re-border-color);\n        border-radius: 12px;\n        padding: 20px 20px 23px 20px;\n        position: relative;\n        margin-top: 13px;\n\n        @media screen and (max-width: 781px) {\n            padding: 16px 20px 23px 20px;\n            height: 270px;\n        }\n\n        span {\n            color: var(--font-color);\n            font-family: Red Hat Display;\n            font-size: 24px;\n            font-style: normal;\n            font-weight: 700;\n            line-height: normal;\n\n            @media screen and (max-width: 781px) {\n                font-size: 24px;\n            }\n        }\n\n        .labList {\n            width: 100%;\n            height: 160px;\n            max-height: 160px;\n            min-height: 160px;\n            margin-top: 16px;\n            overflow-y: hidden;\n            overflow-x: hidden;\n\n            @media screen and (max-width: 781px) {\n                margin-top: 8px;\n            }\n\n            .labItem {\n                display: flex;\n                align-items: flex-start;\n                margin-bottom: 12px;\n\n                .moreItemText {\n                    margin-left: 7px;\n                }\n            }\n        }\n\n        .labList::-webkit-scrollbar,\n        ::-webkit-scrollbar-thumb,\n        ::-webkit-scrollbar-track {\n            background-color: var(--bg-color);\n        }\n\n        .from {\n            color: var(--re-from-color);\n            font-family: Red Hat Display;\n            font-size: 13px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: normal;\n            margin-top: 15px;\n        }\n\n        .labInfo {\n            min-width: 100%;\n            max-width: 100%;\n            display: flex;\n            margin-top: 2px;\n\n            span {\n                margin-right: auto;\n            }\n\n            button {\n                line-height: 16px;\n\n                svg {\n                    top: 35%;\n                }\n            }\n        }\n\n        .logo {\n            width: 53px;\n            height: 38px;\n            position: absolute;\n            top: 17px;\n            right: 24px;\n        }\n    }\n\n    .amount {\n        width: 100%;\n        height: 440px;\n        background-color: var(--sb-bg-color);\n        border-radius: 12px;\n        margin-top: 16px;\n        padding: 11px 20px 20px;\n\n        .selectPlan {\n            width: 100%;\n            background-color: var(--hover-bg-color);\n            border-radius: 12px;\n            border: 1px solid transparent;\n            color: var(--font-dark-color);\n            font-family: Red Hat Display;\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n            padding: 11px 20px 10px 16px;\n            margin-top: 17px;\n        }\n\n        .title {\n            display: flex;\n\n            @media screen and (max-width: 781px) {\n                svg {\n                    width: 32px;\n                    height: 32px;\n                }\n            }\n\n            span {\n                color: var(--font-color);\n                font-family: Red Hat Display;\n                font-size: 20px;\n                font-style: normal;\n                font-weight: 700;\n                line-height: 39px;\n                margin-left: 6px;\n\n                @media screen and (max-width: 781px) {\n                    font-size: 18px;\n                    line-height: 30px;\n                }\n            }\n        }\n\n        .dataLabel {\n            display: flex;\n            margin-top: 13px;\n\n            span {\n                color: var(--re-from-color);\n                text-align: right;\n                font-family: Red Hat Display;\n                font-size: 13px;\n                font-style: normal;\n                font-weight: 500;\n                line-height: normal;\n            }\n\n            span:first-child {\n                margin-left: 9px;\n            }\n\n            span:last-child {\n                margin-left: auto;\n            }\n        }\n\n        .price {\n            display: flex;\n            margin-top: 3px;\n\n            span {\n                color: var(--font-color);\n                font-family: Red Hat Display;\n                font-size: 24px;\n                font-style: normal;\n                font-weight: 700;\n                line-height: normal;\n            }\n\n            span:first-child {\n                margin-left: 9px;\n            }\n\n            span:last-child {\n                margin-left: auto;\n            }\n        }\n\n        .button {\n            width: 100%;\n            display: flex;\n            margin-top: 14px;\n\n            @media screen and (max-width: 781px) {\n                button {\n                    height: 38px !important;\n                }\n            }\n\n            button:last-child {\n                margin-left: 11px;\n            }\n\n            img {\n                top: 22%;\n            }\n        }\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `isp_container__Mxll1`,
	"buttonClicked": `isp_buttonClicked__-YmtF`,
	"buttonNotClicked": `isp_buttonNotClicked__uZtdB`,
	"paymentMethod": `isp_paymentMethod__Zi-eo`,
	"selectPlan": `isp_selectPlan__uZQ3D`,
	"brand": `isp_brand__S6faF`,
	"paymentLabel": `isp_paymentLabel__blDN5`,
	"lab": `isp_lab__TZ4wK`,
	"labList": `isp_labList__hFog-`,
	"labItem": `isp_labItem__o+Hok`,
	"moreItemText": `isp_moreItemText__3EwO8`,
	"from": `isp_from__MgaK4`,
	"labInfo": `isp_labInfo__RjvDF`,
	"logo": `isp_logo__YpGXt`,
	"amount": `isp_amount__uPrGe`,
	"title": `isp_title__Wi1Uw`,
	"dataLabel": `isp_dataLabel__7VrT+`,
	"price": `isp_price__opawT`,
	"button": `isp_button__gIRjY`
};
export default ___CSS_LOADER_EXPORT___;
